import { Fragment } from "react";

import { Container } from "@/components/container";
import {
  Toolbar,
  ToolbarDescription,
  ToolbarHeading,
  ToolbarPageTitle,
} from "@/partials/toolbar";

import { useLayout } from "@/providers";
import { UserFeedbackListings } from "./UserFeedbackLisitings";

const UserFeedbackManagement = () => {
  const { currentLayout } = useLayout();

  return (
    <Fragment>
      {currentLayout?.name === "demo1-layout" && (
        <Container>
          <Toolbar>
            <ToolbarHeading>
              <ToolbarPageTitle id="user-feedback-management-heading" />
              <ToolbarDescription>
                You can manage your user feedback management here.
              </ToolbarDescription>
            </ToolbarHeading>
          </Toolbar>
        </Container>
      )}
      <Container>
        <UserFeedbackListings />
      </Container>
    </Fragment>
  );
};

export { UserFeedbackManagement };
